import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import * as PupilDuplicateActions from './pupil-duplicate.actions';
import {
  selectPupilDuplicateActionInProgressId,
  selectPupilDuplicateError,
  selectPupilDuplicateGroups,
  selectPupilDuplicateLoaded,
  selectPupilDuplicateLoading
} from './pupil-duplicate.selectors';
import { AppState } from '../app.reducer';
import { PupilDuplicateGroup } from '@core/models/domain/pupil-duplicate.domain';

@Injectable({ providedIn: 'root' })
export class PupilDuplicateStoreFacade {
  groups$: Observable<PupilDuplicateGroup[]> = this.store.select(selectPupilDuplicateGroups);
  loading$: Observable<boolean> = this.store.select(selectPupilDuplicateLoading);
  error$: Observable<string | null> = this.store.select(selectPupilDuplicateError);
  actionInProgressId$: Observable<string | null> = this.store.select(selectPupilDuplicateActionInProgressId);

  constructor(private store: Store<AppState>) {}

  load(): void {
    this.store.dispatch(PupilDuplicateActions.loadPupilDuplicates());
  }

  /** For the lists that only hide copies: one load per session is enough. */
  loadIfNeeded(): void {
    this.store.select(selectPupilDuplicateLoaded).pipe(take(1)).subscribe((loaded) => {
      if (!loaded) {
        this.load();
      }
    });
  }

  dismiss(groupId: string): void {
    this.store.dispatch(PupilDuplicateActions.dismissPupilDuplicate({ groupId }));
  }

  /** Takes these copies off the school. */
  removeMembers(groupId: string, accountIds: string[]): void {
    this.store.dispatch(PupilDuplicateActions.removePupilDuplicateMembers({ groupId, accountIds }));
  }
}
